import { Header } from '@components/Header';
import { Helmet } from 'react-helmet-async';
import { Content } from './components/Content';
import { PageProvider } from './providers/PageProvider';

export const AdminTranscriptReviewPage = () => {
  return (
    <>
      <Helmet>
        <title>Transcript Review - AutoScript Admin</title>
      </Helmet>
      <Header title="Transcript Review" />

      <PageProvider>
        <Content />
      </PageProvider>
    </>
  );
};
